var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.577,
    height: 77.577,
    viewBox: "0 0 77.577 77.577",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Icon_awesome-linkedin",
    x: 0,
    y: 0,
    width: 77.577,
    height: 77.577,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-2",
    "data-name": "Icon awesome-linkedin",
    d: "M72.036,2.25H5.524A5.565,5.565,0,0,0,0,7.843V74.234a5.565,5.565,0,0,0,5.524,5.593H72.036a5.58,5.58,0,0,0,5.541-5.593V7.843A5.58,5.58,0,0,0,72.036,2.25ZM23.446,68.745h-11.5V31.722H23.464V68.745ZM17.7,26.666A6.667,6.667,0,1,1,24.364,20,6.67,6.67,0,0,1,17.7,26.666Zm48.85,42.079h-11.5V50.736c0-4.294-.087-9.818-5.974-9.818-5.991,0-6.909,4.675-6.909,9.507V68.745h-11.5V31.722H41.7v5.056h.156A12.111,12.111,0,0,1,52.746,30.8c11.637,0,13.8,7.671,13.8,17.645Z",
    transform: "translate(0 -2.25)",
    fill: "#006151"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Icon_awesome-linkedin)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-linkedin-3",
    "data-name": "Icon awesome-linkedin",
    d: "M72.036,2.25H5.524A5.565,5.565,0,0,0,0,7.843V74.234a5.565,5.565,0,0,0,5.524,5.593H72.036a5.58,5.58,0,0,0,5.541-5.593V7.843A5.58,5.58,0,0,0,72.036,2.25ZM23.446,68.745h-11.5V31.722H23.464V68.745ZM17.7,26.666A6.667,6.667,0,1,1,24.364,20,6.67,6.67,0,0,1,17.7,26.666Zm48.85,42.079h-11.5V50.736c0-4.294-.087-9.818-5.974-9.818-5.991,0-6.909,4.675-6.909,9.507V68.745h-11.5V31.722H41.7v5.056h.156A12.111,12.111,0,0,1,52.746,30.8c11.637,0,13.8,7.671,13.8,17.645Z",
    transform: "translate(0 -2.25)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.8bffc32bb25b7c49d92d654276c1c29d.svg";
export { ForwardRef as ReactComponent };